
export const SendFun = async (
    contract,
    account,
    funname,
    params,
    setLoading,
    value,
    ErrFun
  ) => {
    try {
      setLoading && setLoading(true);
      const tx= await contract.methods[funname](...params).send({
        value,
        from: account,
      });
      ErrFun && ErrFun('');
      console.log('params:',params);
      console.log('funname:',funname);
      return tx;
    } catch (e) {
      console.error("contract:",contract.options.address);
      console.log('params:',params);
      console.error(funname+':',e);
      ErrFun && ErrFun(e);
      setLoading && setLoading(false);
    } finally {
      setLoading && setLoading(false);
    }
  };
  
  export const CallFun = async (
    contract,
    account,
    funname,
    params,
    setLoading,
    value
  ) => {
    try {
      if (contract && contract.methods){
          setLoading && setLoading(true);
          const res= await contract.methods[funname](...params).call({from:account});
          // {value,from: account,}
          console.log('params:',params);
          
          console.log("CallFun called ",funname,"return data:",res);
          return res;
        }
        return null;
    } catch (e) {
      
      console.error("contract:",contract.options.address);
      console.log('params:',params);
      console.error(funname+':',e);
      setLoading && setLoading(false);
    } finally {
      setLoading && setLoading(false);
    }
  };